// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r0on","col":"styles_col__3xCSQ"};